import React, { Fragment } from 'react';
import axios from 'axios';
import { Form, Segment, Header, Input, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { checkOrganizationalUnitsPrivilege } from '../util/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class LeaseholderForm extends React.Component {
    constructor(props) {
        super(props);
        const leaseholder = props.leaseholder || {};
        const isEditing = !!props.leaseholder;
        const entityType = leaseholder.entityType
            ? leaseholder.entityType.id
            : 1;

        this.state = {
            saving: false,
            entityType: entityType,
            physicalEntityName: leaseholder.physicalEntity
                ? leaseholder.physicalEntity.firstName || null
                : null,
            physicalEntityLastName: leaseholder.physicalEntity
                ? leaseholder.physicalEntity.lastName || null
                : null,
            legalEntityName: leaseholder.legalEntity
                ? leaseholder.legalEntity.name || null
                : null,
            legalEntityIdNumber: leaseholder.legalEntity
                ? leaseholder.legalEntity.idNumber || null
                : null,
            organizationalUnit: leaseholder.organizationalUnit
                ? leaseholder.organizationalUnit.id
                : null,
            comment: leaseholder.comment || null,
            errors: {},
        };

        this.sendLeaseholderRequest = this.sendLeaseholderRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.updateLeaseholder = this.updateLeaseholder.bind(this);
    }

    handleInputChange(event, {
        name,
        value
    }) {
        this.setState({
            [name]: value !== '' ? value : null,
        });
    }

    updateLeaseholder(body, leaseholder) {
        const entityUrl = leaseholder.entityType.id === 1
            ? '/assets/physical-entities/'
            : '/assets/legal-entities/';
        const entityData = leaseholder.entityType.id === 1
            ? { firstName: this.state.physicalEntityName,
                lastName: this.state.physicalEntityLastName,
                id: leaseholder.physicalEntity.id,
                optLock: leaseholder.physicalEntity.optLock }
            : { name: this.state.legalEntityName,
                idNumber: this.state.legalEntityIdNumber,
                id: leaseholder.legalEntity.id,
                optLock: leaseholder.legalEntity.optLock };

        return axios.put(entityUrl, entityData).then(() => {
            return axios.put('/assets/leaseholders/', {
                ...body,
                physicalEntity: leaseholder.entityType.id === 1
                    ? { id: leaseholder.physicalEntity.id }
                    : null,
                legalEntity: leaseholder.entityType.id === 2
                    ? { id: leaseholder.legalEntity.id }
                    : null,
                id: leaseholder.id,
                optLock: leaseholder.optLock,
            });
        });
    }

    sendLeaseholderRequest() {
        const { entityType, physicalEntityName, physicalEntityLastName,
                legalEntityName, legalEntityIdNumber, organizationalUnit,
                comment } = this.state;
        const leaseholder = this.props.leaseholder || {};
        const isEditing = !!this.props.leaseholder;

        const errors = {
            organizationalUnitError: !organizationalUnit,
            ...(entityType === 1 && {
                physicalEntityNameError: !physicalEntityName,
                physicalEntityLastNameError: !physicalEntityLastName,
            }),
            ...(entityType === 2 && {
                legalEntityNameError: !legalEntityName,
                legalEntityIdNumberError: !legalEntityIdNumber,
            }),
        };

        if (Object.values(errors).some(v => v)) {
            this.setState({ errors });
            toast('Nisu sva potrebna polja popunjena!');
            return;
        }

        const body = {
            entityType: { id: entityType },
            physicalEntity: entityType === 1
                ? { firstName: physicalEntityName, lastName: physicalEntityLastName }
                : null,
            legalEntity: entityType === 2
                ? { name: legalEntityName, idNumber: legalEntityIdNumber }
                : null,
            organizationalUnit: organizationalUnit ? { id: organizationalUnit } : null,
            comment: comment || '',
        };

        const apiCall = isEditing
            ? this.updateLeaseholder(body, leaseholder)
            : axios.post('/assets/leaseholders/', body);

        this.setState({ saving: true }, () => {
            apiCall
                .then(() => {
                    this.setState({ saving: false });
                    toast(isEditing ? 'Zahtjev uspješno uređen!' : 'Zahtjev uspješno poslan!');
                    if (this.props.onRefreshData) this.props.onRefreshData();
                    if (this.props.onCloseForm) this.props.onCloseForm();
                })
                .catch(() => {
                    this.setState({ saving: false });
                    toast('Došlo je do greške!');
                });
        });
    }

    render() {
        const {
            entityTypes,
            organizationalUnits
        } = this.props;
        const {
            saving,
            entityType,
            physicalEntityName,
            physicalEntityLastName,
            legalEntityName,
            legalEntityIdNumber,
            comment,
        } = this.state;
        const isEditing = !!this.props.leaseholder;

        return (
            <Fragment>
                <Segment secondary>
                    <Form noValidate>
                        <Form.Group widths="equal">
                            <Form.Dropdown
                                clearable
                                placeholder="Izaberite tip zakupca"
                                value={entityType}
                                onChange={this.handleInputChange}
                                name="entityType"
                                options={entityTypes}
                                search
                                fluid
                                selection
                                required
                            />
                            <Form.Field/>
                            <Form.Field/>
                            <Form.Field/>
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment secondary raised clearing>
                    <Form noValidate>
                        {checkOrganizationalUnitsPrivilege(this.props.activeRole) && (
                            <Form.Group widths="equal">
                                <Form.Dropdown
                                    clearable
                                    label="Članica"
                                    placeholder="Članica"
                                    value={this.state.organizationalUnit}
                                    onChange={this.handleInputChange}
                                    name="organizationalUnit"
                                    options={organizationalUnits}
                                    search
                                    fluid
                                    selection
                                    error={this.state.errors.organizationalUnitError}
                                />
                            </Form.Group>
                        )}
                        {entityType === 1 && (
                            <Form.Group widths="equal">
                                <Form.Field
                                    label="Ime"
                                    control={Input}
                                    name="physicalEntityName"
                                    value={physicalEntityName}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite ime"
                                    required
                                    error={this.state.errors.physicalEntityNameError}
                                />
                                <Form.Field
                                    label="Prezime"
                                    control={Input}
                                    name="physicalEntityLastName"
                                    value={physicalEntityLastName}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite prezime"
                                    required
                                    error={this.state.errors.physicalEntityLastNameError}
                                />
                                <Form.Field
                                    label="Napomena"
                                    control={Input}
                                    name="comment"
                                    value={comment}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite napomenu"
                                />
                            </Form.Group>
                        )}
                        {entityType === 2 && (
                            <Form.Group widths="equal">
                                <Form.Field
                                    label="Naziv"
                                    control={Input}
                                    name="legalEntityName"
                                    value={legalEntityName}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite naziv"
                                    required
                                    error={this.state.errors.legalEntityNameError}
                                />
                                <Form.Field
                                    label="ID"
                                    control={Input}
                                    name="legalEntityIdNumber"
                                    value={legalEntityIdNumber}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite naziv"
                                    required
                                    error={this.state.errors.legalEntityIdNumberError}
                                />
                                <Form.Field
                                    label="Napomena"
                                    control={Input}
                                    name="comment"
                                    value={comment}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite napomenu"
                                />
                            </Form.Group>
                        )}
                        <Button floated="right" onClick={() => this.props.onCloseForm()} basic color="blue"
                                disabled={saving}>Odustani</Button>
                        <Button floated="right" color="blue" loading={saving} disabled={saving} onClick={this.sendLeaseholderRequest}>
                            {this.props.leaseholder ? 'Izmijeni' : 'Sačuvaj'}
                        </Button>
                    </Form>
                </Segment>
            </Fragment>
        );
    }
}

export default LeaseholderForm;



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderForm.js